import { createPortal } from 'react-dom';
import { Spinner } from '@/components/ui/spinner';

interface CenteredSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  /** When true, renders via portal on document.body to guarantee true viewport centering */
  fullScreen?: boolean;
}

/**
 * Standardized centered loader for pages and sections.
 * - Default: flex-1 to fill available parent space + min-h for standalone contexts.
 * - fullScreen: portaled fixed overlay covering the entire viewport, escaping any parent container.
 */
export function CenteredSpinner({ size = 'md', fullScreen = false }: CenteredSpinnerProps) {
  if (fullScreen) {
    return createPortal(
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/60 backdrop-blur-sm">
        <Spinner size={size} />
      </div>,
      document.body,
    );
  }
  return (
    <div className="flex-1 flex items-center justify-center min-h-[200px] w-full">
      <Spinner size={size} />
    </div>
  );
}
